import React from 'react'
import { useTranslation } from 'react-i18next';
import DocumentationSidebar from '../component/DocumentationSidebar'
import { useDocImage } from '../hooks/useDocImage';

export default function Dashboard() {
  const { t } = useTranslation();
  
  const image001 = useDocImage('dashboard-img', 'image001.png');
  const image002 = useDocImage('dashboard-img', 'image002.png');
  const image003 = useDocImage('dashboard-img', 'image003.png');
  const image004 = useDocImage('dashboard-img', 'image004.png');
  const image005 = useDocImage('dashboard-img', 'image005.png');
  const image006 = useDocImage('dashboard-img', 'image006.png');
  const image008 = useDocImage('dashboard-img', 'image008.png');
  const image009 = useDocImage('dashboard-img', 'image009.png');

  return (
    <>
      <div className='d-flex flex-column main-outer-wrapper'>
        <div className="flex-grow-1 d-flex survey-main-wrapper">
          <DocumentationSidebar />

          {/* Dashboard Content */}
          <div className="flex-grow-1 dashboard-page-outer">
            <div className='dashboard-page-wrap document-page-wrap'>

              <h1 className='mt-0 text-primary'>{t('documentation.dashboard.title')}</h1>
              <p className='header-para'>
                {t('documentation.dashboard.intro')}
              </p>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.dashboard.navigating.title')}
                </div>
                <div className="card-body">
                  <ul>
                    <li>{t('documentation.dashboard.navigating.step1')}</li>
                    <li>{t('documentation.dashboard.navigating.step2')}</li>
                    <li>{t('documentation.dashboard.navigating.step3')}
                      <img src={image001} alt={t('documentation.dashboard.navigating.imageAlt')} className='img-fluid pt-20 pb-10' />
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.dashboard.header.title')}
                </div>
                <div className="card-body">
                  <img src={image002} alt={t('documentation.dashboard.navigating.imageAlt')} className='img-fluid pt-10 pb-20' />
                 
                  <p><b>{t('documentation.dashboard.header.userProfile')}</b></p>
                  <ul>
                    <li>{t('documentation.dashboard.header.userProfileItems.languageDropdown')}</li>
                    <li>{t('documentation.dashboard.header.userProfileItems.userProfile')}</li>
                    <li>{t('documentation.dashboard.header.userProfileItems.dropdownMenu')}</li>
                  </ul>
                  <img src={image003} alt={t('documentation.dashboard.navigating.imageAlt')} className='img-fluid pt-10 pb-20' />
                  <p><b>{t('documentation.dashboard.header.breadcrumb')}</b></p>
                  
                  <ul>
                    <li>{t('documentation.dashboard.header.breadcrumbDesc')}</li>
                  </ul>

                  <p><b>{t('documentation.dashboard.header.createSurvey')}</b></p>
                  <ul>
                    <li>{t('documentation.dashboard.header.createSurveyItems.location')}</li>
                    <li>{t('documentation.dashboard.header.createSurveyItems.purpose')}</li>
                  </ul>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.dashboard.filters.title')}
                </div>
                <div className="card-body">
                  <p>{t('documentation.dashboard.filters.intro')}</p>

                  <p><b>{t('documentation.dashboard.filters.searchBar')}</b> - {t('documentation.dashboard.filters.searchBarDesc')}</p>
                 
                  <img src={image004} alt={t('documentation.dashboard.navigating.imageAlt')} className='img-fluid pb-30' />

                  <p><b>{t('documentation.dashboard.filters.filtersTitle')}</b> - {t('documentation.dashboard.filters.filtersDesc')}</p>
                  <ul>
                    <li><b>{t('documentation.dashboard.filters.languageFilter')}</b> - {t('documentation.dashboard.filters.languageFilterDesc')}</li>
                    
                    <li>{t('documentation.dashboard.filters.allLanguages')}</li>
                    <img src={image005} alt={t('documentation.dashboard.navigating.imageAlt')} className='pb-30' />
                      
                    
                    <li><b>{t('documentation.dashboard.filters.statusFilter')}</b> - {t('documentation.dashboard.filters.statusFilterDesc')} <br />
                    <img src={image006} alt={t('documentation.dashboard.navigating.imageAlt')} className='pt-10 pb-30' />
                      <ul>
                        <li>{t('documentation.dashboard.filters.statusOptions.all')}</li>
                        <li>{t('documentation.dashboard.filters.statusOptions.published')}</li>
                        <li>{t('documentation.dashboard.filters.statusOptions.draft')}</li>
                        <li>{t('documentation.dashboard.filters.statusOptions.example')}</li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.dashboard.tableColumns.title')}
                </div>
                <div className="card-body">
                  <img src={image008} alt={t('documentation.dashboard.navigating.imageAlt')} className='img-fluid pt-10 pb-10' />
                  <p>{t('documentation.dashboard.tableColumns.intro')}</p>
                  <ul>
                    <li><b>{t('documentation.dashboard.tableColumns.surveyName').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.surveyName').split(' - ')[1]}</li>
                    <li><b>{t('documentation.dashboard.tableColumns.completion').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.completion').split(' - ')[1]}</li>
                    <li><b>{t('documentation.dashboard.tableColumns.language').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.language').split(' - ')[1]}</li>
                    <li><b>{t('documentation.dashboard.tableColumns.status').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.status').split(' - ')[1]}</li>
                    <li><b>{t('documentation.dashboard.tableColumns.addedOn').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.addedOn').split(' - ')[1]}</li>
                    <li><b>{t('documentation.dashboard.tableColumns.lastModified').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.lastModified').split(' - ')[1]}</li>
                    <li><b>{t('documentation.dashboard.tableColumns.publishedOn').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.publishedOn').split(' - ')[1]}</li>
                    <li><b>{t('documentation.dashboard.tableColumns.actions').split(' - ')[0]}</b> - {t('documentation.dashboard.tableColumns.actions').split(' - ')[1]}</li>
                  </ul>
                </div>
              </div>

              <div className="card dashboard-card mb-4">
                <div className="card-header d-md-flex justify-content-between align-items-center px-3">
                  {t('documentation.dashboard.actions.title')}
                </div>
                <div className="card-body">
                  <img src={image009} alt={t('documentation.dashboard.navigating.imageAlt')} className='pt-10 pb-10' />
                  <ul>
                    <li><b>{t('documentation.dashboard.actions.editSurvey.label')}</b> {t('documentation.dashboard.actions.editSurvey.desc')}</li>
                    <li><b>{t('documentation.dashboard.actions.shareSurvey.label')}</b> {t('documentation.dashboard.actions.shareSurvey.desc')}</li>
                    <li><b>{t('documentation.dashboard.actions.moveToPublish.label')}</b> {t('documentation.dashboard.actions.moveToPublish.desc')}</li>
                    <li><b>{t('documentation.dashboard.actions.viewLeads.label')}</b> {t('documentation.dashboard.actions.viewLeads.desc')}</li>
                    <li><b>{t('documentation.dashboard.actions.duplicate.label')}</b> {t('documentation.dashboard.actions.duplicate.desc')}</li>
                    <li><b>{t('documentation.dashboard.actions.delete.label')}</b> {t('documentation.dashboard.actions.delete.desc')}</li>
                  </ul>
                </div>
              </div>

            </div>
          </div>

        </div>
      </div>
    </>
  )
}
